module.exports = __webpack_public_path__ + "static/media/dice-d8.f5cf3ab8.svg";